module.exports = __webpack_public_path__ + "static/media/profile-kristen.70f76623.jpg";